import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { FabricProcessingFabric } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class FabricProcessingFabricService extends TmsWebBaseEditCreateService<
  FabricProcessingFabric,
  FabricProcessingFabric
> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('FabricProcessingFabric', $localize`Fabric Processing`, httpService, notificationService);
  }

  getForProduct(id: string): Observable<FabricProcessingFabric[]> {
    return this.httpService.get<FabricProcessingFabric[]>(`${this.apiUrl}/Product/${id}`);
  }
}
